<!--Outbound>Resource Planning New-->
<template :height="mainHeight">
    <div class="mains" style="overflow: scroll;" :style="{height:mainHeight}">
        <a-form :form="formQuery" style="margin: 0 0 5px 5px;">
            <a-row>
                <a-col style="width: 34%;float: left;">
                    <a-row>
                        <a-form-item class="genericFrom">
                            <a-row style="font-size: large">
                                <b>Wave Id:</b>
                            </a-row>
                            <a-row style="float: left;width: 100%">
                                <a-col style="width: 47%;float: left">
                                    <a-input v-model="waveId" @pressEnter="query"/>
                                </a-col>
                                <a-col style="float:right;">
                                    <a-button type="primary" style="margin-left: 10px;" @click="query">Search</a-button>
                                    <a-button type="primary" style="margin-left: 10px;" @click="showCreate">Create</a-button>
                                    <a-button type="primary" style="margin-left: 10px;" @click="save" v-if="canSave">Save</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                    </a-row>
                    <a-row>
                        <a-row style="width: 100%;z-index: 2;margin-top: 10px;">
                            <a-row>
                                <b>Remark:</b>
                            </a-row>
                            <a-row>
                                <a-textarea size="small" v-model="this.headerData.remark" disabled style="font-size: small;height: 60px;"/>
                            </a-row>
                        </a-row>
                    </a-row>
                </a-col>
                <a-col class="dateClass" style="margin-left: 2%;">
                    <a-form-item class="genericFrom">
                        <a-row style="font-size: large">
                            <b>Plan Start Date:</b>
                        </a-row>
                        <a-row>
                            <a-date-picker class="datePickerStyle" style="width: 100%;" size="large" format="YYYY/MM/DD" @change="changeStartDate"
                                           v-decorator="['planStartDate',{initialValue: this.headerData == null ? '' : this.headerData.planStartDate}]"/>
                        </a-row>
                    </a-form-item>
                    <a-row style="margin-top: 5px;height: 30px;">
                        <a-col>
                            <a-checkbox :checked="workingDayonly" @change="changeDayOnly"></a-checkbox>
                            {{$t('resPlan.workingDayOnly')}}
                        </a-col>
                    </a-row>
                </a-col>
                <a-col class="dateClass">
                    <a-form-item class="genericFrom">
                        <a-row>
                            <b style="font-size: large">Projected Finish Date:</b>
                        </a-row>
                        <a-row style="border-radius: 5px;background-color: #FAFAFA;font-size: large;height: 60px;">
                            <a-row>{{this.projectedFinishDateOld}}</a-row>
                            <a-row>{{this.projectedFinishDateWeekOld}}</a-row>
                        </a-row>
                    </a-form-item>
                </a-col>
                <a-col class="dateClass">
                    <a-form-item class="genericFrom">
                        <a-row style="color: #2EA0D7;font-size: large">
                            <b>Projected Finish Date:</b>
                        </a-row>
                        <a-row style="border-radius: 5px;background-color: #FAFAFA;font-size: large;height: 60px;">
                            <a-row>{{this.projectedFinishDateCurrent}}</a-row>
                            <a-row>{{this.projectedFinishDateWeekCurrent}}</a-row>
                        </a-row>
                    </a-form-item>
                </a-col>
                <a-col class="dateClass">
                    <a-form-item class="genericFrom">
                        <a-row style="font-size: large">
                            <b>Actual Finished Date:</b>
                        </a-row>
                        <a-row>
                            <a-date-picker class="datePickerStyle2" style="width: 100%;" size="large" format="YYYY/MM/DD" @change="changeActDate"
                                           v-decorator="['actualFinishedDate',{initialValue: this.headerData == null ? '' : this.headerData.actualFinishedDate}]"/>
                        </a-row>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col ref="refLeftHeight" style="width: 16%;float: left;">
                    <a-row>
                        <a-col>
                            <a-form-item class="genericFrom">
                                <a-row>
                                    <b>Plan Date</b>
                                </a-row>
                                <a-row class="garyBgColor">
                                    {{this.headerData.planDate}} {{this.headerData.planDateWeek}}
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col>
                            <a-form-item class="genericFrom">
                                <a-row>
                                    <b>Principal</b>
                                </a-row>
                                <a-row class="garyBgColor" style="background-color: #F6C3C3">
                                    {{this.headerData.principal}}
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col>
                            <a-form-item class="genericFrom">
                                <a-row>
                                    <b>Total Number of Units(Wave)</b>
                                </a-row>
                                <a-row class="garyBgColor" style="background-color: #F6C3C3">
                                    {{this.headerData.totalNumberOfUnits}}
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col>
                            <a-form-item class="genericFrom">
                                <a-row>
                                    <b>Product Description</b>
                                </a-row>
                                <a-row class="garyBgColor">
                                    {{this.headerData.productDescription}}
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col>
                            <a-form-item class="genericFrom">
                                <a-row>
                                    <b>Material Required</b>
                                </a-row>
                                <a-row class="garyBgColor">
                                    {{this.headerData.materialRequired}}
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col>
                            <a-form-item class="genericFrom">
                                <a-row>
                                    <b>Supporting Equipment</b>
                                </a-row>
                                <a-row class="garyBgColor">
                                    {{this.headerData.supportingEquipment}}
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col style="width: 82%;float: right;margin-top: -30px;z-index: 1;">
                    <table cellpadding="0" cellspacing="0" class="table-list">
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Estimation</td>
                            <td></td>
                            <td>Actual</td>
                        </tr>
                        <tr>
                            <td>Process</td>
                            <td>Productivity<br>(Unit)</td>
                            <td>Required<br>Workers</td>
                            <td width="280px;">
                                <div class="table-flex">
                                    <div>Number<br>of Workers</div>
                                    <div>Workers<br>Throughput</div>
                                </div>
                            </td>
                            <td></td>
                            <td width="280px;">Number<br>of Workers</td>
                        </tr>
                        <template v-for="item in this.detailData">
                            <tr>
                                <td>{{item.description}}</td>
                                <td>{{item.productity}}</td>
                                <td>{{item.estWorker}}</td>
                                <td>
                                    <a-input-number v-model:value="item.numberOfWorkers" :min="1" :max="100" @change="workersChange(false)"/>
                                    <a-input-number v-model:value="item.workersThroughput = item.productity * item.numberOfWorkers" :disabled="disWorkThr" style="margin-left: 20px"/>
                                </td>
                                <td></td>
                                <td>
                                    <a-input-number v-model:value="item.actWorker" :min="1" :max="100" style="width: 70%"/>
                                </td>
                            </tr>
                        </template>
                    </table>
                </a-col>
            </a-row>
            <a-row>
                <a-col>
                    <a-form-item class="genericFrom">
                        <a-row>
                            <b>Value-added Services Required</b>
                        </a-row>
                        <a-row class="garyFloatBgColor" style="width: 100%;text-align: left;padding-left: 10px;min-height: 70px;">
                            {{this.headerData.valueServicesRequired1}}<br v-if="this.headerData.valueServicesRequired1 != null && this.headerData.valueServicesRequired1.length > 0">
                            {{this.headerData.valueServicesRequired2}}<br v-if="this.headerData.valueServicesRequired2 != null && this.headerData.valueServicesRequired2.length > 0">
                            {{this.headerData.valueServicesRequired3}}<br v-if="this.headerData.valueServicesRequired3 != null && this.headerData.valueServicesRequired3.length > 0">
                            {{this.headerData.valueServicesRequired4}}<br v-if="this.headerData.valueServicesRequired4 != null && this.headerData.valueServicesRequired4.length > 0">
                            {{this.headerData.valueServicesRequired5}}<br v-if="this.headerData.valueServicesRequired5 != null && this.headerData.valueServicesRequired5.length > 0">
                            {{this.headerData.valueServicesRequired6}}<br v-if="this.headerData.valueServicesRequired6 != null && this.headerData.valueServicesRequired6.length > 0">
                            {{this.headerData.valueServicesRequired7}}<br v-if="this.headerData.valueServicesRequired7 != null && this.headerData.valueServicesRequired7.length > 0">
                            {{this.headerData.valueServicesRequired8}}<br v-if="this.headerData.valueServicesRequired8 != null && this.headerData.valueServicesRequired8.length > 0">
                            {{this.headerData.valueServicesRequired9}}<br v-if="this.headerData.valueServicesRequired9 != null && this.headerData.valueServicesRequired9.length > 0">
                            {{this.headerData.valueServicesRequired10}}<br v-if="this.headerData.valueServicesRequired10 != null && this.headerData.valueServicesRequired10.length > 0">
                        </a-row>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col>
                    <a-form-item class="genericFrom">
                        <a-row>
                            <b>Special Attention</b>
                        </a-row>
                        <a-row>
                            <a-textarea size="small" v-model="this.headerData.specialAttention" disabled style="font-size: small;background-color: #EAEAEA;height: 70px;"/>
                        </a-row>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>

        <!--WaveId弹出窗-->
        <search-wave ref="queryWindow" @createResPlan="createResPlan"></search-wave>
    </div>
</template>

<script>
    import searchWave from "./components/searchWave";
    import XEUtils from "xe-utils";
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import Template from "./reportCom/template";
    import moment from "moment";
    export default {
        components:{
            Template,
            searchWave
        },
        data() {
            return {
                waveId:"",
                mainHeight:document.body.clientHeight-100+'px',
                workingDayonly:true,
                formQuery: this.$form.createForm(this, {}),
                numberWorkers:1,
                workersThroughput:1,
                detailData:[],
                headerData:[],
                projectedFinishDateOld:'',
                projectedFinishDateWeekOld:'',
                projectedFinishDateCurrent:'',
                projectedFinishDateWeekCurrent:'',
                canSave:false,
                disWorkThr:true,
            }
        },
        methods: {
            query(){
                if (this.waveId.length < 1) {
                    this.$customMessage.warning(this.$t('resPlan.waveIdNotnull'), 2);
                    return;
                }
                this.canSave = false;
                let params = {//配置查询条件
                    waveId : this.waveId,
                }
                ajax.post(api.GETRESPLANHEADER,params).then(res=>{
                    if(res.code == 200){
                        this.projectedFinishDateOld = ''
                        this.projectedFinishDateWeekOld = ''
                        this.projectedFinishDateCurrent = ''
                        this.projectedFinishDateWeekCurrent = ''
                        this.headerData = res.data;//主数据
                        this.formQuery.setFieldsValue({"planStartDate":this.headerData.planStartDate});
                        this.formQuery.setFieldsValue({"actualFinishedDate":this.headerData.actualFinishedDate});
                        ajax.post(api.GETRESPLANDETAIL,params).then(res=>{
                            if(res.code == 200){
                                this.detailData = res.data;//列表
                                if(this.detailData.length > 0){
                                    this.canSave = true;
                                }else{//如果没有查询到数据,并且Wave已存在,则弹出是否创建ResourcePlan提示
                                    let that = this
                                    ajax.post(api.CHECKRESPLANCREATE,params).then(res=>{
                                        if(res.code == 200){
                                            this.$customConfirm({
                                                title: that.$t('resPlan.needCreateResourcePlan'),
                                                okText: that.$t('publicLang.Confirm'),
                                                cancelText: that.$t('publicLang.Cancel'),
                                                okType: 'confirm',
                                                onOk() {
                                                    that.createResPlan(that.waveId);
                                                },
                                                onCancel() {}
                                            })
                                        }else{
                                            this.$customMessage.warning(res.msg,2);
                                        }
                                    })
                                }
                                this.workersChange(true);
                            }
                        })
                    }
                })
            },
            showCreate(){
                this.$refs.queryWindow.show("")
            },
            createResPlan(row) {
                if(row == null || row == undefined || row.length < 1){
                    this.$customMessage.warning(this.$t('resPlan.waveIdNotnull'),2);
                    return;
                }
                let params = {
                    waveId : row
                }
                ajax.post(api.CREATERESPLANDATA,params).then(res=>{
                    if(res.code == 200){
                        this.waveId = row
                        this.$message.success('Submit Success')
                        this.query();
                    }else{
                        this.$customMessage.warning(res.msg,2);
                    }
                })
            },
            save(){
                if (this.waveId.length < 1) {
                    this.$customMessage.warning(this.$t('resPlan.waveIdNotnull'), 2);
                    return;
                }
                if (this.headerData.planStartDate == 'Invalid date') {
                    this.$customMessage.warning("Plan Start Date " + this.$t('job.notNull'), 2);
                    return;
                }
                let params = {
                    waveId : this.waveId,
                    planStartDate:this.headerData.planStartDate,
                    actualFinishedDate:this.headerData.actualFinishedDate,
                    detailData:this.detailData
                }
                ajax.post(api.SAVERESPLANDATA,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(this.$t('pubGicSet.SaveSuccess'))
                        this.query();
                    }
                })
            },
            changeStartDate(val){
                this.headerData.planStartDate = moment(val).format('YYYY/MM/DD')
                this.workersChange(true)
            },
            changeActDate(val){
                this.headerData.actualFinishedDate = moment(val).format('YYYY/MM/DD')
            },
            changeDayOnly(){
                this.workingDayonly = !this.workingDayonly
                this.workersChange(true)
            },
            workersChange(change){
                if(this.headerData.planStartDate == null || this.headerData.planStartDate == 'Invalid date'){
                    return;
                }
                let minWorkersThr = 0;//最小生产力
                let totalWorkersThr = this.headerData.totalNumberOfUnits;//所需生产力
                for (let i = 0; i < this.detailData.length; i++) {
                    if(minWorkersThr == 0){
                        minWorkersThr = this.detailData[i].numberOfWorkers * this.detailData[i].productity
                    }
                    if(this.detailData[i].numberOfWorkers * this.detailData[i].productity < minWorkersThr){
                        minWorkersThr = this.detailData[i].numberOfWorkers * this.detailData[i].productity
                    }
                }
                if(minWorkersThr > 0 && totalWorkersThr > 0){
                    let days = totalWorkersThr / minWorkersThr;//所需天数
                    let mo = totalWorkersThr % minWorkersThr;
                    let nextDay = days;//往后数几天
                    if(mo == 0){
                        nextDay = nextDay - 1;
                    }else{
                        nextDay = parseInt(nextDay);
                    }
                    let startDate = new Date(moment(this.headerData.planStartDate).format('YYYY/MM/DD'))//开始时间
                    if(this.workingDayonly){//只计算工作日
                        let lastDate = new Date(moment(startDate.setDate(startDate.getDate() - 1)).format("YYYY/MM/DD"));//开始时间的前一天
                        let nextDaysArray = [];//后面的日期集合
                        while(true){
                            let nextDays = moment(lastDate.setDate(lastDate.getDate() + 1)).format("YYYY/MM/DD")//后一天
                            let week = new Date(nextDays).getDay();//星期
                            if(week == 1 || week == 2 || week == 3 || week == 4 || week == 5){//如果日期是周六或周日,则跳过
                                nextDaysArray.push(nextDays);
                                if(nextDaysArray.length == nextDay + 1){
                                    this.projectedFinishDateCurrent = nextDays;
                                    this.projectedFinishDateWeekCurrent = this.getWeek(week);
                                    break;
                                }
                            }
                        }
                    }else{
                        let newProjectedFinishDate = moment(startDate.setDate(startDate.getDate() + nextDay)).format("YYYY/MM/DD")
                        let day = new Date(newProjectedFinishDate).getDay();
                        this.projectedFinishDateCurrent = newProjectedFinishDate;
                        this.projectedFinishDateWeekCurrent = this.getWeek(day);
                    }
                    if(change){
                        this.projectedFinishDateOld = this.projectedFinishDateCurrent
                        this.projectedFinishDateWeekOld = this.projectedFinishDateWeekCurrent
                    }
                }
            },
            getWeek(days){//获取星期几
                let week;
                switch(days) {
                    case 1:
                        week = 'Monday';
                        break;
                    case 2:
                        week = 'Tuesday';
                        break;
                    case 3:
                        week = 'Wednesday';
                        break;
                    case 4:
                        week = 'Thursday';
                        break;
                    case 5:
                        week = 'Friday';
                        break;
                    case 6:
                        week = 'Saturday';
                        break;
                    case 0:
                        week = 'Sunday';
                        break;
                }
                return week;
            }
        }
    }
</script>

<style>
    .mains{
        width: 100%;
        background-color: white;
        float: left;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 10px;
    }
    .dateClass{
        text-align: center;
        width: 15%;
        margin-left: 1%;
        float: left;
    }
    .garyBgColor{
        min-height: 50px;
        text-align: center;
        font-size: large;
        padding-top: 9px;
        background-color: #f5f5f5;
        border-radius: 5px;
    }
    .garyFloatBgColor{
        border: 1px solid #d9d9d9;
        line-height: 20px;
        text-align: center;
        padding-top: 9px;
        background-color: #f5f5f5;
        border-radius: 5px;
    }
    .datePickerStyle .ant-input{
        height: 60px;
        font-size: x-large;
        text-align: center;
    }
    .datePickerStyle2 .ant-input{
        height: 60px;
        font-size: x-large;
        color: limegreen;
        text-align: center;
    }

    /*::-webkit-scrollbar {display:none}*/

    .table-list{width: 100%;}
    .table-list *{ text-align: center;}
    .table-list tr:nth-child(-n + 2) td{ font-weight: bold; background-color: #ffffff!important;}
    .table-list tr:nth-child(-n + 2) td:after,.table-list tr:nth-child(-n + 2) td:before{ display: none!important;}
    .table-list tr:nth-child(2) td:nth-child(4):before{ display: block!important;}
    .table-list tr td:first-child{ text-align: left;}
    .table-list tr td:nth-child(-n + 3){ background-color: #F7F7F7;}
    .table-list tr td{border-right: 10px solid #ffffff; padding: 15px 10px; position: relative;}
    .table-list tr td:nth-child(-n + 3):after{ width: 100%; height: 8px; right: 0; top: 0; content: ''; z-index: 2; display: inline-block;
        clear: both; position: absolute; background-color: #ffffff;}
    .table-list tr td:nth-child(-n + 3):before{ width: 100%; height: 3px; left: 0; bottom: -1px; content: ''; z-index: 1; display: inline-block;
        clear: both; position: absolute; background-color: #00ccff;}
    .table-list tr td:nth-child(n + 4){ border: 1px solid #D9D9D9; border-bottom: 0; border-top: 0; }
    .table-list tr:nth-child(2) td:nth-child(4){ border: 1px solid #D9D9D9; border-bottom: 0; border-top-right-radius: 4px;}
    .table-list tr td:nth-child(4):before{ width: 1px; height: 100%; left: 0; top: 0; content: ''; z-index: 1; display: inline-block;
        clear: both; position: absolute; background-color: #D9D9D9;}
    .table-list tr:last-child td:nth-child(n + 4){ border-bottom: 1px solid #D9D9D9;}
    .table-list tr td:nth-child(5){ border: 0!important; padding: 5px;}
    .table-list tr:nth-child(-n + 2) td:nth-child(4),
    .table-list tr td:last-child{ border-left: 1px solid #D9D9D9;}
    .table-list tr:nth-child(2) td:last-child{ border-top: 1px solid #D9D9D9; border-top-left-radius: 4px; border-top-right-radius: 4px;}
    .table-list tr:last-child td:last-child,
    .table-list tr:last-child td:nth-child(4)
    { border-bottom-right-radius: 4px; border-bottom-left-radius: 4px;}
    .table-list tr:first-child td{ border: 0!important;}
    .table-flex{ width: 100%; display: flex;}
    .table-flex>div{ width: 50%;}
</style>